import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../../decorators'
import { getTsdContactRoleListData } from './mockData'
import type { IContactRole } from '~/types/contact/models'

// get

interface GetTsdContactRolesResponse {
  data: IContactRole[]
}

async function getTsdContactRoles(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetTsdContactRolesResponse = {
    data: await getTsdContactRoleListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postTsdContactRole = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getTsdContactRoleListData)
}

const patchTsdContactRole = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getTsdContactRoleListData)
}

const deleteTsdContactRole = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getTsdContactRoleListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/tsdcontactroles',
    handler: getTsdContactRoles,
  },
  {
    method: 'post',
    path: '/api/tsdcontactroles',
    handler: postTsdContactRole,
  },
  {
    method: 'patch',
    path: '/api/tsdcontactroles/:id',
    handler: patchTsdContactRole,
  },
  {
    method: 'delete',
    path: '/api/tsdcontactroles/:id',
    handler: deleteTsdContactRole,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
